
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/d373630d6537f2b05ea3760230c302e1.jfif"
              alt="Bible Believers Tabernacle"
              className="h-12 md:h-16 w-auto mb-3 md:mb-4"
            />
            <p className="text-gray-600 mb-3 md:mb-4 max-w-md text-sm md:text-base">
              Making a positive impact in communities worldwide through sustainable projects and compassionate action. Together, we can create lasting change.
            </p>
          </div>
          
          <div>
            <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-3 md:mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/projects" className="text-gray-600 hover:text-blue-600 cursor-pointer text-sm md:text-base">Our Projects</Link></li>
              <li><Link to="/about" className="text-gray-600 hover:text-blue-600 cursor-pointer text-sm md:text-base">About Us</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-3 md:mb-4">Contact Info</h3>
            <div className="space-y-2 text-gray-600 text-sm md:text-base">
              <div className="flex items-start space-x-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs md:text-sm"></i>
                </div>
                <span>55-7-47 Old Venkojipalem, Visakhpatnam, India 530022</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs md:text-sm"></i>
                </div>
                <span>+1943-238-3483</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs md:text-sm"></i>
                </div>
                <span>ameethed@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-6 md:mt-8 pt-4 md:pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-xs md:text-sm">
            © 2024 NGO Organization. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-3 md:mt-0">
            <Link to="/privacy" className="text-gray-600 hover:text-blue-600 text-xs md:text-sm cursor-pointer">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-blue-600 text-xs md:text-sm cursor-pointer">Terms of Service</Link>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 text-xs md:text-sm cursor-pointer">Made with Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
